import clsx from 'clsx'
import { createPortal } from 'react-dom'
import { NavLink, useNavigate } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'

import { ReactComponent as CloseSvg } from '../../../assets/svgs/close-circle.svg'
import { Button } from '../../../components/Button'
import { useAuth } from '../../../contexts/AuthContext'

type MobileMenuProps = {
  isOpen: boolean
  onClose: () => void
}

export const MobileMenu = ({ isOpen, onClose }: MobileMenuProps) => {
  const navigate = useNavigate()
  const { signOut, user } = useAuth()

  const handleSignOut = () => {
    signOut()
    navigate(`/${user!.type === 'expert' ? 'expert' : 'painel'}/logout`)
  }

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="admin-mobile-menu"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed top-0 bottom-0 left-0 right-0 z-50 flex-col h-full p-6 overflow-hidden overflow-y-scroll bg-white"
        >
          <header className="mb-[70px]">
            <button onClick={onClose} className="block mb-12 ml-auto">
              <CloseSvg />
            </button>
            <div>
              <span className="block mb-3 text-lg font-normal text-grey-900 ">
                {user?.name}
              </span>
              <span className="text-base font-normal  text-grey-700">
                {user?.email}
              </span>
            </div>
          </header>

          <ul className="flex flex-col flex-1">
            <li className="pb-6">
              <NavLink
                to="/painel/dashboard"
                onClick={onClose}
                className={({ isActive }) =>
                  clsx('text-base font-normal', {
                    'text-primary-light font-bold': isActive,
                    'text-grey-800': !isActive,
                  })
                }
              >
                Home
              </NavLink>
            </li>
            <li className="py-6 border-t border-grey-300">
              <NavLink
                to="/painel/registers"
                onClick={onClose}
                className={({ isActive }) =>
                  clsx('text-base font-normal', {
                    'text-primary-light font-bold': isActive,
                    'text-grey-800': !isActive,
                  })
                }
              >
                Cadastros
              </NavLink>
            </li>
            <li className="py-6 border-t border-grey-300">
              <NavLink
                to="/painel/projects"
                onClick={onClose}
                className={({ isActive }) =>
                  clsx('text-base font-normal', {
                    'text-primary-light font-bold': isActive,
                    'text-grey-800': !isActive,
                  })
                }
              >
                Projetos
              </NavLink>
            </li>
            <li className="py-6 border-t border-grey-300">
              <NavLink
                to="/painel/meetings"
                onClick={onClose}
                className={({ isActive }) =>
                  clsx('text-base font-normal', {
                    'text-primary-light font-bold': isActive,
                    'text-grey-800': !isActive,
                  })
                }
              >
                Reuniões
              </NavLink>
            </li>
            <li className="py-6 border-t border-grey-300">
              <NavLink
                to="/painel/database"
                onClick={onClose}
                className={({ isActive }) =>
                  clsx('text-base font-normal', {
                    'text-primary-light font-bold': isActive,
                    'text-grey-800': !isActive,
                  })
                }
              >
                Base de dados
              </NavLink>
            </li>
            <li className="py-6 border-t border-grey-300">
              <NavLink
                to="/painel/requests"
                onClick={onClose}
                className={({ isActive }) =>
                  clsx('text-base font-normal', {
                    'text-primary-light font-bold': isActive,
                    'text-grey-800': !isActive,
                  })
                }
              >
                Request
              </NavLink>
            </li>
            <li className="py-6 border-t border-grey-300">
              <NavLink
                to="/painel/change-password"
                onClick={onClose}
                className={({ isActive }) =>
                  clsx('text-base font-normal', {
                    'text-primary-light font-bold': isActive,
                    'text-grey-800': !isActive,
                  })
                }
              >
                Alterar senha
              </NavLink>
            </li>
          </ul>

          <footer className="flex justify-center w-32 mx-auto mt-12">
            <Button onClick={handleSignOut} variant="outline" fullWidth>
              Sair
            </Button>
          </footer>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  )
}
